import { render } from "./Journeys.vue?vue&type=template&id=2b83d1e2&scoped=true"
import script from "./Journeys.vue?vue&type=script&lang=js"
export * from "./Journeys.vue?vue&type=script&lang=js"

import "./Journeys.vue?vue&type=style&index=0&id=2b83d1e2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83d1e2"]])

export default __exports__